import React, { useState, useEffect } from 'react';
import { Calendar, MapPin, Clock } from 'lucide-react';
import EnvelopeOpening from '../components/EnvelopeOpening';
import HeartReveal from '../components/HeartReveal';
import CountdownTimer from '../components/CountdownTimer';
import LocationCard from '../components/LocationCard';
import '../styles/WeddingInvite.css';

const WeddingInvite = () => {
  const [isEnvelopeOpen, setIsEnvelopeOpen] = useState(false);
  const [dateRevealed, setDateRevealed] = useState({
    day: false,
    month: false,
    year: false
  });

  const weddingData = {
    bride: 'Priyadharshini',
    groom: 'Sathish',
    date: {
      day: '18',
      month: 'May',
      year: '2026',
      full: 'Monday, 18th May 2026'
    },
    ceremony: {
      time: '6:00 A.M. to 7:30 A.M.',
      venue: 'Sri Subramaniya Swamy Temple',
      location: 'Mailam',
      address: 'Sri Subramaniya Swamy Temple, Mailam',
      mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Sri+Subramaniya+Swamy+Temple+Mailam'
    },
    reception: {
      time: '7:00 P.M. onwards',
      venue: 'D.K.P. Thirumana Mandapam',
      location: 'Tindivanam',
      address: 'D.K.P. Thirumana Mandapam, Tindivanam',
      mapsUrl: 'https://www.google.com/maps/search/?api=1&query=D.K.P.+Thirumana+Mandapam+Tindivanam'
    },
    messages: {
      title: 'Join us in celebrating',
      subtitle: 'Together with our families, we invite you to celebrate the beginning of our forever',
      tagline: 'Celebrate with us — Love, Laughter & Togetherness',
      closing: 'Your presence will make our day truly special'
    }
  };

  const handleEnvelopeOpen = () => {
    setIsEnvelopeOpen(true);
  };

  const handleHeartReveal = (type) => {
    setDateRevealed(prev => ({ ...prev, [type]: true }));
  };

  const addToCalendar = () => {
    const event = {
      text: `${weddingData.groom} & ${weddingData.bride} Wedding`,
      dates: '20260518T060000/20260518T193000',
      details: `Marriage Ceremony at ${weddingData.ceremony.venue}, ${weddingData.ceremony.location}\nReception at ${weddingData.reception.venue}, ${weddingData.reception.location}`,
      location: weddingData.ceremony.address
    };
    
    const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.text)}&dates=${event.dates}&details=${encodeURIComponent(event.details)}&location=${encodeURIComponent(event.location)}`;
    window.open(googleCalendarUrl, '_blank');
  };

  if (!isEnvelopeOpen) {
    return <EnvelopeOpening onOpen={handleEnvelopeOpen} bride={weddingData.bride} groom={weddingData.groom} />;
  }

  return (
    <div className="wedding-invite-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <p className="hero-subtitle">{weddingData.messages.title}</p>
          <h1 className="couple-names">
            {weddingData.groom}
            <span className="ampersand">♥</span>
            {weddingData.bride}
          </h1>
          <p className="hero-tagline">{weddingData.messages.subtitle}</p>
          <div className="divider-ornament">❦</div>
        </div>
      </section>

      {/* Date Reveal Section */}
      <section className="date-reveal-section">
        <h2 className="section-title">Save the Date</h2>
        <p className="reveal-instruction">Tap the hearts to reveal our special day</p>
        <div className="hearts-container">
          <HeartReveal 
            value={weddingData.date.day}
            label="Day"
            isRevealed={dateRevealed.day}
            onReveal={() => handleHeartReveal('day')}
          />
          <HeartReveal 
            value={weddingData.date.month}
            label="Month"
            isRevealed={dateRevealed.month}
            onReveal={() => handleHeartReveal('month')}
          />
          <HeartReveal 
            value={weddingData.date.year}
            label="Year"
            isRevealed={dateRevealed.year}
            onReveal={() => handleHeartReveal('year')}
          />
        </div>
        <p className="full-date">{weddingData.date.full}</p>
      </section>

      {/* Countdown Section */}
      <section className="countdown-section">
        <h2 className="section-title">Counting Down to Forever</h2>
        <CountdownTimer targetDate="2026-05-18T06:00:00" />
      </section>

      {/* Celebration Message */}
      <section className="celebration-section">
        <div className="celebration-card">
          <p className="celebration-text">{weddingData.messages.tagline}</p>
        </div>
      </section>

      {/* Ceremony Section */}
      <section className="ceremony-section">
        <h2 className="section-title">Marriage Ceremony</h2>
        <LocationCard 
          icon={<MapPin />}
          venue={weddingData.ceremony.venue}
          location={weddingData.ceremony.location}
          time={weddingData.ceremony.time}
          mapsUrl={weddingData.ceremony.mapsUrl}
          bgImage="https://images.unsplash.com/photo-1624253321171-1be53e12f5f4"
        />
      </section>

      {/* Reception Section */}
      <section className="reception-section">
        <h2 className="section-title">Reception</h2>
        <LocationCard 
          icon={<Clock />}
          venue={weddingData.reception.venue}
          location={weddingData.reception.location}
          time={weddingData.reception.time}
          mapsUrl={weddingData.reception.mapsUrl}
          bgImage="https://images.unsplash.com/photo-1528164344705-47542687000d"
        />
      </section>

      {/* Calendar Button */}
      <section className="calendar-section">
        <button className="calendar-button" onClick={addToCalendar}>
          <Calendar className="button-icon" />
          Add to Calendar
        </button>
      </section>

      {/* Closing Message */}
      <section className="closing-section">
        <p className="closing-message">{weddingData.messages.closing}</p>
        <div className="divider-ornament">❦</div>
        <p className="signature">With love,<br />{weddingData.groom} ♥ {weddingData.bride}</p>
      </section>
    </div>
  );
};

export default WeddingInvite;